module.exports = __webpack_public_path__ + "static/img/1-12.e8f95e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/1-12.png
// module id = j+Qp
// module chunks = 0